/**
 * CSV Export Utility
 * Takes array of objects and column definitions, triggers browser download.
 * columnDefs: [{ key: 'name', label: 'Company Name' }, ...]
 */
export function downloadCSV(data, columnDefs, filename) {
  if (!data || data.length === 0) {
    alert('No data to export.');
    return;
  }

  // Escape a CSV field: wrap in quotes if it contains comma, quote, or newline
  const escapeField = (value) => {
    if (value === null || value === undefined) return '';
    const str = String(value);
    if (str.includes(',') || str.includes('"') || str.includes('\n') || str.includes('\r')) {
      return '"' + str.replace(/"/g, '""') + '"';
    }
    return str;
  };

  // Build header row
  const header = columnDefs.map(col => escapeField(col.label)).join(',');

  // Build data rows
  const rows = data.map(row => {
    return columnDefs.map(col => {
      // Support nested keys with dot notation (e.g., 'owner.email')
      let value = row;
      const keys = col.key.split('.');
      for (const k of keys) {
        value = value?.[k];
      }
      // If a formatter is provided, use it
      if (col.format && typeof col.format === 'function') {
        value = col.format(value, row);
      }
      return escapeField(value);
    }).join(',');
  });

  const csvContent = [header, ...rows].join('\n');

  // Trigger download via Blob + anchor click
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', filename.endsWith('.csv') ? filename : filename + '.csv');
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
